<script setup>
import { computed } from "vue"


defineEmits(['hide-window'])
const props = defineProps(['curStep'])
const theText = computed(() => {
    let text = ''
    switch (props.curStep) {
        case 0:
            text = 'Tab on your SpaceBarShip to \nstart earning light years'
            break;
        case 1:
            text = 'Press your spacebar to \nstart earning light years'
            break;
        case 2:
            text = 'Buy your first alien to help \nyou in your space journey'
            break;
    }
    return text
})


</script>

<template>
 <div id="tutorial">
    <h3>{{ theText }}</h3>
 </div>
</template>

<style scoped>
#tutorial {
    position: absolute;
    width: 400px;
    height: 100px;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    border: 3px solid aqua;
    border-radius: 20px;
    padding: 10px;
    box-shadow: 0 0 20px 20px black;
}

#tutorial h3 {
    text-align: center;
    color: black;
}

@media screen and (max-width: 1000px) {

    #tutorial {
        width: 250px;
        height: fit-content;
        left: calc(100% - 260px);
        transform: unset;
        top: 160px;
        overflow-y: auto;
        padding: 5px;
    }
}
</style>